module.exports = __webpack_public_path__ + "img/IMG_8974.0e83ded9.jpg";